import { useEffect } from "react";
import { IEmployeeTraining } from "../../../models/staff/employeeTraining";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import TrainingHelpVideo from "./components/trainingHelpVideo";
import EmployeeTraining from "./components/EmployeeTraining";
import TrainingMatrics from "./components/trainingMatrics";
import { getPageBlockData } from "../../../common-functions/commonFunctions";
import { setSnapShots } from "../../../store/slices/master/snapShotSlice";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";
import { pageBlockId } from "../../../constants/pageBlocks";
import WeekCalendar from "../../../common-components/calendar/weekCalendar";

const StaffEmployeeTraining = (props: IEmployeeTraining) => {
  const { getSnapShots, snapShots } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getSnapShots();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSnapShots([]));
    };
  }, []);

  return (
    <>
      <div className="row staftrng-mobile">
        <div className="col-lg-4">
          <EmployeeTraining />
        </div>
        <div className="col-lg-4">
          <div className="row h-100">
            <TrainingMatrics />
            <TrainingHelpVideo />
          </div>
        </div>
        <div className="col-lg-4">
          <WeekCalendar />
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
};

function mapStateToProps(state: any) {
  return {
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffEmployeeTraining);
